import React, { Component } from 'react';
import { connect } from "react-redux";
import { login, loggedOut } from './redux/actions'
import { db, auth } from './config/firebase';

import s from './redux/selectors'

import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import Main from './Main';
import Register from './components/screens/register/register';

class App extends Component {
  constructor(props){
    super(props);
  }
  componentWillMount() {
    // listener authentication
    auth.onAuthStateChanged(user => {
      if(user) {
        console.log("USER", user)
        this.props.login(user)
      } else {
        this.props.loggedOut();
      }
    })
  }
  render() {
    console.log("USER", this.props.loggedInUser);
    return (
      <Router>
        <div>
          <Route exact={true} path="/" component={NoCustomer}/>
          <Route exact={true} path="/:customerId" component={Main}/>
          <Route exact={true} path="/register/:customerId/:id" component={Register}/>
        </div>
      </Router>
    );
  }
}

class NoCustomer extends Component {
  render(){
    return (
      <div>
        No customer
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.general.user,
    loggedInUser: state.loggedInUserId
  };
}

export default connect(mapStateToProps, { login, loggedOut })(App);
